import { GuestBot } from "../../interfaces"

export interface PayloadFormData {
  type: GuestBot.PayloadType
  text?: string
  parseMode?: GuestBot.ParseMode
  media?: string
  title?: string
  mime?: "application/pdf" | "application/zip"
  buttons?: GuestBot.Button[][]
}

const clean = <T extends object>(o: T): T =>
  Object.fromEntries(
    Object.entries(o).filter(
      ([, v]) => v !== undefined && v !== "" && v !== null,
    ),
  ) as T

export const toPayload = (f: PayloadFormData): GuestBot.ResponsePayload => {
  const base: GuestBot.ResponsePayload = { type: f.type }
  if (f.text) base.text = f.text
  if (f.parseMode) base.parseMode = f.parseMode
  if (f.type !== "text") base.media = f.media
  if (f.type === "document") {
    base.title = f.title
    base.mime = f.mime
  }
  if (f.buttons?.length) base.buttons = f.buttons
  return clean(base)
}

export const fromPayload = (p: GuestBot.ResponsePayload): PayloadFormData => ({
  type: p.type ?? "text",
  text: p.text ?? "",
  parseMode: p.parseMode ?? null,
  media: p.media ?? "",
  title: p.title ?? "",
  mime: p.mime ?? "application/pdf",
  buttons: p.buttons,
})

export const isUrl = (v?: string) => {
  if (!v) return false
  try {
    // eslint-disable-next-line no-new
    new URL(v)
    return true
  } catch {
    return false
  }
}

export const validatePayload = (f: PayloadFormData): string | null => {
  if (f.type === "text") {
    if (!f.text) return "Укажите текст сообщения"
    return null
  }
  if (!isUrl(f.media)) return "Укажите корректную ссылку (URL) на файл"
  if (f.type === "document") {
    if (!f.title) return "Укажите заголовок (title) документа"
    if (f.mime !== "application/pdf" && f.mime !== "application/zip")
      return "Тип документа: только PDF или ZIP"
  }
  return null
}
